import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BANNERS } from '@/mocks';

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % BANNERS.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const banner = BANNERS[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="推荐内容横幅">
      {BANNERS.map((item, index) => (
        <div
          key={item.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-background-950" />

      <div className="absolute inset-0 flex items-end pb-12 md:pb-16">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-[1440px] mx-auto">
            <div className="max-w-2xl" key={banner.id}>
              <div className="flex items-center gap-3 mb-3">
                <span className="px-3 py-1 rounded-full text-xs font-semibold bg-accent-500 text-background-50 whitespace-nowrap">
                  {banner.tag}
                </span>
                <span className="flex items-center gap-1 text-sm text-accent-400">
                  <i className="ri-star-fill text-accent-500"></i>
                  {banner.rating}
                </span>
              </div>
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-3 leading-tight">
                <Link to={banner.href} className="hover:text-primary-400 transition-colors">
                  {banner.title}
                </Link>
              </h1>
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed line-clamp-2 mb-5">
                {banner.description}
              </p>
              <Link
                to={banner.href}
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-colors whitespace-nowrap"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                立即观看
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 right-4 md:right-6 flex gap-2">
        {BANNERS.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              index === current
                ? 'bg-primary-500 w-6'
                : 'bg-foreground-500/40 hover:bg-foreground-500/60'
            }`}
            aria-label={`切换到第${index + 1}张横幅`}
          />
        ))}
      </div>
    </section>
  );
}